var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EEEDF2;}\r\n\t.st1{fill:none;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#EFC12F;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#1E247E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#1E247E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#FCF5F2;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#FCF5F2;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:#1E247E;}\r\n\t.st8{fill:none;stroke:#1E247E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#EAB8B1;}\r\n\t.st10{fill:#DC9695;stroke:#1E247E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st11{fill:#EECED1;stroke:#1E247E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st12{fill:#CB7272;stroke:#1E247E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st13{fill:#D3D5E7;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st14{fill:#D3D5E7;}\r\n\t.st15{fill:#FFFFFF;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st16{fill:#FFFFFF;stroke:#1E247E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st17{fill:#ECECEE;}\r\n\t.st18{fill:#DA867D;stroke:#1E247E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st19{fill:#FCF5F2;stroke:#1E247E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st20{fill:#69AEF8;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st21{opacity:0.4;fill:#FFFFFF;}\r\n\t.st22{opacity:0.7;fill:#FFFFFF;}\r\n\t.st23{fill:#69ADF7;stroke:#1E247E;stroke-width:2.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st24{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st25{fill:none;stroke:#1E247E;stroke-width:2.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st26{fill:#F0C330;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st27{opacity:0.3;}\r\n\t.st28{fill:#FFFFFF;}\r\n\t.st29{fill:#79CAA1;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st30{fill:#DA867D;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st31{fill:#FFFFFF;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st32{fill:#DBE7FE;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st33{fill:#F2F3F3;}\r\n\t.st34{fill:none;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st35{fill:#DBE7FE;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st36{fill:#EFC230;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st37{fill:none;stroke:#1E247E;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st38{fill:#F0C330;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st39{fill:#79CAA1;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st40{fill:#FFFFFF;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st41{fill:#DA867D;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st42{fill:#DBE7FE;stroke:#1E247E;stroke-width:6;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st43{fill:none;stroke:#1E247E;stroke-width:6;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st44{opacity:0.7;}\r\n\t.st45{fill:#FFFFFF;stroke:#1E247E;stroke-width:6;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st46{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st47{fill:none;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st48{fill:#DBE7FE;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st49{opacity:0.1;fill:#BDBDBD;}\r\n\t.st50{fill:#69AEF8;stroke:#1E247E;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st51{fill:#79CAA1;stroke:#1E247E;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st52{fill:#D2D4E6;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st53{fill:#69AEF8;stroke:#1E247E;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st54{opacity:0.2;fill:none;stroke:#1E247E;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st55{fill:none;stroke:#1E247E;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st56{fill:#69AEF8;stroke:#1E247E;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st57{fill:#DBE7FE;}\r\n\t.st58{fill:#FFFFFF;stroke:#1E247E;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st59{fill:#D9857D;stroke:#1E247E;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st60{fill:none;stroke:#D3D5E7;stroke-width:4.7904;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st61{fill:#D2D4E6;stroke:#D3D5E7;stroke-width:4.7904;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st62{fill:#D2D4E6;stroke:#D3D5E7;stroke-width:5.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st63{fill:none;stroke:#D3D5E7;stroke-width:5.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st64{fill:#79CAA1;}\r\n\t.st65{fill:#F0C330;}\r\n\t.st66{fill:#79CAA1;stroke:#1E247E;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st67{opacity:0.8;fill:#FFFFFF;}\r\n\t.st68{fill:#DA867D;stroke:#1E247E;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st69{fill:#F0C330;stroke:#1E247E;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st70{fill:#D2D4E6;}\r\n\t.st71{fill:#EEBDBC;stroke:#D3D5E7;stroke-width:5.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st72{fill:#D3D5E7;stroke:#D3D5E7;stroke-width:5.5;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Documents_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 252.9,
    cy: 252.5,
    id: "Background_18_",
    r: 215.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shadows_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M228.6,441.2l64.8-112.3c2.8-4.8,1.1-11-3.7-13.8l-159-91.8c-4.8-2.8-11-1.1-13.8,3.7       L52.1,339.3c-2.8,4.8-1.1,11,3.7,13.8l159,91.8C219.6,447.6,225.8,446,228.6,441.2z",
    id: "_x31_st_16_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205.7,400.5L307.3,320c4.4-3.5,5.1-9.8,1.6-14.1l-114-144c-3.5-4.4-9.8-5.1-14.1-1.6       L79.2,240.8c-4.4,3.5-5.1,9.8-1.6,14.1l114,144C195,403.2,201.3,404,205.7,400.5z",
    id: "_x32_nd_16_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M327.3,353.2H197.6c-5.6,0-10.1-4.5-10.1-10.1V159.5c0-5.6,4.5-10.1,10.1-10.1h129.7       c5.6,0,10.1,4.5,10.1,10.1v183.6C337.4,348.7,332.9,353.2,327.3,353.2z",
    id: "_x33_rd_15_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M316,394.2l-99.4-83.3c-4.3-3.6-4.8-9.9-1.2-14.2l118-140.7c3.6-4.3,9.9-4.8,14.2-1.2       l99.4,83.3c4.3,3.6,4.8,9.9,1.2,14.2L330.2,393C326.6,397.2,320.3,397.8,316,394.2z",
    id: "_x34_th_7_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M293.2,432.1l-55-117.4c-2.4-5-0.2-11,4.8-13.4l166.3-77.9c5-2.4,11-0.2,13.4,4.8      l55,117.4c2.4,5,0.2,11-4.8,13.4L306.6,437C301.5,439.3,295.5,437.2,293.2,432.1z",
    id: "_x35_th_2_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Documents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_st_15_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M217.2,451.5l64.8-112.3c2.8-4.8,1.1-11-3.7-13.8l-159-91.8c-4.8-2.8-11-1.1-13.8,3.7       L40.8,349.6c-2.8,4.8-1.1,11,3.7,13.8l159,91.8C208.3,458,214.4,456.3,217.2,451.5z",
    id: "Shape_70_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M47.3,353.6c-0.7,1.2-0.3,2.7,0.9,3.4",
    id: "Line_28_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x32_nd_15_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M203.6,403.5L305.3,323c4.4-3.5,5.1-9.8,1.6-14.1l-114-144c-3.5-4.4-9.8-5.1-14.1-1.6       L77.1,243.8c-4.4,3.5-5.1,9.8-1.6,14.1l114,144C192.9,406.3,199.3,407,203.6,403.5z",
    id: "Shape_69_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M80.7,249c-1.3,1-1.5,2.9-0.5,4.1",
    id: "Line_27_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33_rd_14_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M316,363.6H186.3c-5.6,0-10.1-4.5-10.1-10.1V169.9c0-5.6,4.5-10.1,10.1-10.1H316       c5.6,0,10.1,4.5,10.1,10.1v183.6C326,359.1,321.5,363.6,316,363.6z",
    id: "Shape_68_"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27",
    id: "Content_12_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M252.4,221.6h-54c-1.6,0-3-1.3-3-3v-10.1c0-1.6,1.3-3,3-3h54c1.6,0,3,1.3,3,3v10.1        C255.3,220.3,254,221.6,252.4,221.6z",
    id: "Bottom_60_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M274.1,197.5h-75.3c-1.9,0-3.5-1.5-3.5-3.5v-9.1c0-1.9,1.5-3.5,3.5-3.5h75.3        c1.9,0,3.5,1.5,3.5,3.5v9.1C277.6,195.9,276.1,197.5,274.1,197.5z",
    id: "Top_62_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M183.6,170.7c0-2,1.7-3.7,3.7-3.7",
    id: "Line_26_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x34_th_6_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.2,404.6l-99.4-83.3c-4.3-3.6-4.8-9.9-1.2-14.2l118-140.7c3.6-4.3,9.9-4.8,14.2-1.2       l99.4,83.3c4.3,3.6,4.8,9.9,1.2,14.2l-118,140.7C320.8,407.6,314.5,408.2,310.2,404.6z",
    id: "Shape_67_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M334,173.8c1.3-1.5,3.6-1.7,5.1-0.4",
    id: "Line_25_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x35_th_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M281.8,442.5l-55-117.4c-2.4-5-0.2-11,4.8-13.4l166.3-77.9c5-2.4,11-0.2,13.4,4.8       l55,117.4c2.4,5,0.2,11-4.8,13.4l-166.3,77.9C290.2,449.7,284.2,447.5,281.8,442.5z",
    id: "Shape_66_"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27",
    id: "Content_11_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M391.4,352.8l-32-68.2c-0.8-1.7-0.1-3.8,1.7-4.6l8.2-3.9c1.7-0.8,3.8-0.1,4.6,1.7l32,68.2        c0.8,1.7,0.1,3.8-1.7,4.6l-8.2,3.9C394.3,355.3,392.2,354.5,391.4,352.8z",
    id: "Left_44_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M413.9,342.2L382,274c-0.8-1.7-0.1-3.8,1.7-4.6l8.2-3.9c1.7-0.8,3.8-0.1,4.6,1.7l32,68.2        c0.8,1.7,0.1,3.8-1.7,4.6l-8.2,3.9C416.8,344.7,414.7,344,413.9,342.2z",
    id: "Right_43_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M399.1,243.3c1.9-0.9,4.1-0.1,5,1.8",
    id: "Line_24_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_line_13_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    id: "Right_42_",
    x1: 416.2,
    x2: 469,
    y1: 468.1,
    y2: 468.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    id: "Middle_52_",
    x1: 80.1,
    x2: 399.1,
    y1: 468.1,
    y2: 468.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    id: "Left_43_",
    x1: 37.7,
    x2: 63.8,
    y1: 468.1,
    y2: 468.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M396.9,303.8v133.4c0,17.1-13.9,31-31,31H144.7c-17.1,0-31-13.9-31-31V270      c0-21.3,17.3-38.6,38.6-38.6h89.6c11.8,0,22.9,5.4,30.2,14.6l12.1,15.2c3.2,4,8.1,6.4,13.3,6.4h63.2      C380.7,267.6,396.9,283.8,396.9,303.8z",
    id: "Shape_65_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Folder_outer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Holes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 211.1,
    cy: 272.3,
    id: "_x33_rd_13_",
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 185.1,
    cy: 272.3,
    id: "_x32_nd_14_",
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 159.2,
    cy: 272.3,
    id: "_x31_st_14_",
    r: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_31_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    id: "Bottom_59_",
    x1: 228.5,
    x2: 236.5,
    y1: 328.5,
    y2: 334.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    id: "Middle_51_",
    x1: 228.5,
    x2: 244.5,
    y1: 320.8,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    id: "Top_61_",
    x1: 240.1,
    x2: 244.5,
    y1: 321.9,
    y2: 325.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.8,283.4c6.4,1.8,11.4,7.1,12.7,13.7",
    id: "Line_23_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vertical_line_4_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    id: "Bottom_58_",
    x1: 381.5,
    x2: 381.5,
    y1: 331.9,
    y2: 364.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    id: "Top_60_",
    x1: 381.5,
    x2: 381.5,
    y1: 321.4,
    y2: 325.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content_10_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M246,426.5H146c-2.7,0-4.9-2.2-4.9-4.9v-54c0-2.7,2.2-4.9,4.9-4.9h100        c2.7,0,4.9,2.2,4.9,4.9v54C250.9,424.3,248.7,426.5,246,426.5z",
    id: "Bottom_57_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M188.2,350.7h-44.9c-1.6,0-2.9-1.3-2.9-2.9v-28.5c0-1.6,1.3-2.9,2.9-2.9h44.9        c1.6,0,2.9,1.3,2.9,2.9v28.5C191.2,349.3,189.9,350.7,188.2,350.7z",
    id: "Top_59_"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Sparkles_17_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right_41_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Bottom_56_",
    x1: 369.1,
    x2: 360.8,
    y1: 126.5,
    y2: 129.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Middle_50_",
    x1: 359.8,
    x2: 353.2,
    y1: 114.7,
    y2: 122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Top_58_",
    x1: 344.5,
    x2: 345.8,
    y1: 116.1,
    y2: 106.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Left_42_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Bottom_55_",
    x1: 111.7,
    x2: 102.5,
    y1: 161,
    y2: 159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Middle_49_",
    x1: 110.4,
    x2: 117.7,
    y1: 145.7,
    y2: 152.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st24",
    id: "Top_57_",
    x1: 122.3,
    x2: 124.9,
    y1: 136.5,
    y2: 144.8
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.393aee63d995bff4652ebc126b208e11.svg";
export { ForwardRef as ReactComponent };